// extracted by mini-css-extract-plugin
export default {"wrapper":"ShowTariffValue_wrapper__0vQhG","valueWrapper":"ShowTariffValue_valueWrapper__8Wi2J"};